import { render, staticRenderFns } from "./dashboard-component.vue?vue&type=template&id=4ebd0a14"
import script from "./dashboard-component.vue?vue&type=script&lang=ts"
export * from "./dashboard-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports